import { render, staticRenderFns } from "./changeApprove.vue?vue&type=template&id=2529fe96&scoped=true&"
import script from "./changeApprove.vue?vue&type=script&lang=js&"
export * from "./changeApprove.vue?vue&type=script&lang=js&"
import style0 from "./changeApprove.vue?vue&type=style&index=0&id=2529fe96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2529fe96",
  null
  
)

export default component.exports